import { gql } from '@apollo/client';

export const UPDATE_PLAYER_SEASON = gql`
  mutation UpdatePlayerSeason($players: [Int!], $season: Int!) {
    update_players(
      where: { id: { _in: $players } }
      _set: { lastSeason: $season }
    ) {
      affected_rows
      returning {
        id
        lastSeason
      }
    }
  }
`;
